export const ONLINE_BOT_APPEARANCE_LIMIT = 16;

function shuffledCopy(items, random) {
  const shuffled = [...items];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const randomValue = Number(random());
    const normalized = Number.isFinite(randomValue)
      ? Math.min(.999999999, Math.max(0, randomValue))
      : 0;
    const target = Math.floor(normalized * (index + 1));
    [shuffled[index], shuffled[target]] = [shuffled[target], shuffled[index]];
  }
  return shuffled;
}

function randomizedCycle(items, count, random) {
  const available = items.filter((item) => item?.id);
  const result = [];
  while (available.length && result.length < count) {
    result.push(...shuffledCopy(available, random).slice(0, count - result.length));
  }
  return result;
}

/**
 * Arma apariencias completas para bots. Cada ranura usa su propio mazo
 * barajado, por lo que las combinaciones cambian en cada partida y a la vez
 * se evita que todos los bots reciban casualmente el mismo cosmético.
 */
export function createBotAppearanceDeck({
  cars = [],
  cosmeticSlots = [],
  count = 0,
  defaultLoadoutFor = () => ({}),
  colliderFor = null,
  random = Math.random,
} = {}) {
  const appearanceCount = Math.max(0, Math.floor(Number(count) || 0));
  const carDeck = randomizedCycle(cars, appearanceCount, random);
  const slotDecks = new Map(cosmeticSlots.map((slot) => [
    slot.id,
    randomizedCycle(slot.catalog || [], appearanceCount, random),
  ]));

  return carDeck.map((car, index) => {
    const loadout = { ...(defaultLoadoutFor(car) || {}) };
    cosmeticSlots.forEach((slot) => {
      const cosmetic = slotDecks.get(slot.id)?.[index];
      if (cosmetic?.id) loadout[slot.id] = cosmetic.id;
    });
    const appearance = { carId:car.id, loadout };
    if (colliderFor) appearance.collider = colliderFor(car) || null;
    return appearance;
  });
}
